// The keepalive allowance the two event senders share on teardown.
//
// A browser refuses a keepalive request once the bodies of all the keepalive
// requests a page has in flight would pass 64 KiB. The batched event queue and the
// play-time note flush both send over keepalive on the same signals (page hidden,
// pagehide, app backgrounded), so each one claims the size of a body before it
// sends and gives it back when the request settles. The play-time notes send first
// and claim first; the queue takes what is left, up to its own share.
//
// Sizes are JSON characters, as the senders measure their bodies. The allowance
// stays a few KB under 64 KiB to cover characters that encode to more than one byte.
const KEEPALIVE_ALLOWANCE_CHARS = 60 * 1024;

let claimedChars = 0;

// What a new keepalive body may still use without pushing the page past the limit.
export const keepaliveCharsAvailable = (): number =>
  Math.max(0, KEEPALIVE_ALLOWANCE_CHARS - claimedChars);

// Claims chars for a keepalive body about to be sent. Call the returned function
// when the request settles; calling it again does nothing.
export const claimKeepaliveChars = (chars: number): (() => void) => {
  claimedChars += chars;
  let released = false;
  return () => {
    if (released) return;
    released = true;
    claimedChars -= chars;
  };
};
